import { buildUrl, sort } from '../../utils/helpers';
import actionHelpers from '../../utils/action-helpers';
import axios from 'axios';
const path = process.env.VUE_APP_ROOT_API;

const state = {
  status: null,
  items: [],
  heading: '',
  description: '',
  nextUrl: null,
  total: null,
  errors: [],
  num: 12,
  filters: {
    mold: [],
    pose: [],
    bodyColor: [],
    theme: []
  },
  displayStyle: 'grid',
  sorts: [
    {
      direction: 'asc',
      field: 'name',
      active: true,
      label: 'Name'
    },
    {
      direction: 'asc',
      field: 'averagePrice',
      active: false,
      label: 'Average Price'
    }
  ]
};

const getters = {
  getById: state => id => {
    return state.items.find(o => {
      return o.id === id;
    });
  },
  getBySlug: state => slug => {
    return state.items.find(o => {
      return o.slug === slug;
    });
  },
  getPoniesByColor: state => slug => {
    return state.items.filter(o => {
      return o.body_color.slug === slug;
    });
  },
  getImages: state => slug => {
    const pony = state.items.find(o => {
      return o.slug === slug;
    });

    return pony ? pony.images : [];
  },
  getAll: state => {
    return state.items;
  },
  getPoniesByMold: ({ items }) => slug => {
    return items.filter(({ mold }) => {
      return mold.slug === slug;
    });
  },
  getPoniesByPose: state => slug => {
    return state.items.filter(o => {
      return o.pose.slug === slug;
    });
  },
  getPoniesByCharacter: state => slug => {
    return state.items.filter(o => {
      return o.character.slug === slug;
    });
  },
  getPoniesByGrouping: state => slug => {
    return state.items.filter(o => {
      return o.grouping.slug === slug;
    });
  },
  getPoniesByTheme: state => theme => {
    return state.items.filter(o => {
      const slug = theme;
      return o.themes.find(theme => {
        return theme.slug === slug;
      });
    });
  },
  getPoniesByHairColor: state => hairColor => {
    return state.items.filter(o => {
      const slug = hairColor;
      return o.hair_colors.find(hair_color => {
        return hair_color.slug === slug;
      });
    });
  },
  getFilters: state => () => {
    return state.filters;
  }
};

const actions = {
  RESET_ERRORS: actionHelpers.RESET_ERRORS,
  RESET_STATUS: actionHelpers.RESET_STATUS,
  CLEAR_ITEMS: ({ commit }) => {
    commit('CLEAR_ITEMS');
  },
  FETCH_ALL: ({ commit, dispatch }, { num }) => {
    // fetch an initial list of ponies
    commit('CLEAR_ITEMS');

    const sort = () => {
      const activeSort = state.sorts.filter(o => o.active)[0];

      dispatch('SORT', {
        direction: activeSort.direction,
        field: activeSort.field
      });
    };

    actionHelpers.FETCH_ALL(`${path}/api/ponies/${num}`, sort)({
      commit,
      dispatch
    });
  },
  FETCH_MORE: ({ commit, dispatch }, payload) => {
    // fetch the next page of ponies if there is a next page
    let url = buildUrl(`${state.nextUrl}`, payload);

    actionHelpers.FETCH_MORE(url)({ commit, dispatch });
  },
  FETCH: async ({ commit, dispatch }, { slug }) => {
    if (!slug) {
      return;
    }
  
    try {
      const { data: { item: pony } } = await axios.get(`${path}/api/pony/${slug}`);

      if (pony) {
        return Promise.all([
          dispatch('FETCH_IMAGES', { slug }),
          dispatch('FETCH_VARIANTS', { slug }),
          dispatch('FETCH_RELATED', { slug }),
          dispatch('accessory/FETCH_PONY_ACCESSORIES', { slug }, { root: true }),
          dispatch('comment/FETCH', { slug }, {
            root: true
          })
        ]).then(values => {
          const [
            images,
            variants,
            related,
            accessories,
            comments,
          ] = values;
          pony.images = images;
          pony.variants = variants;
          pony.related = related;
          pony.accessories = accessories;
          commit('comment/ADD', comments, { root: true });
          commit('ADD_PONY', pony);

          return pony;
        })
      }
    } catch (error) {
      console.error(error);
      // commit('SET_ERROR', error);
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not fetch pony. try again later.',
        { root: true }
      );
    }
  },
  FETCH_IMAGES: async ({ commit, dispatch }, { slug }) => {
    try {
      const { data } = await axios.get(`${path}/api/pony/${slug}/images`);

      if (data && data.images && data.images.length) {
        return data.images.map((o, index) => {
          if (index === 0) {
            o.show = true;
          } else {
            o.show = false;
          }
  
          return o;
  
        });
      }

      return [];
    } catch (error) {
      console.error(error);
      commit('SET_ERROR', error);
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not fetch images for this pony. try again later.',
        { root: true }
      );
    }
  },
  ADD_IMAGES: async ({ commit, dispatch }, { slug }) => {
    const images = await dispatch('FETCH_IMAGES', { slug });

    commit('ADD_IMAGES', {
      images,
      slug: slug
    });
  },
  UPDATE_IMAGES: async ({ commit }, { slug, image }) => {
    commit('UPDATE_IMAGES', {
      slug,
      currentImage: image
    });
  },
  FETCH_VARIANTS: async ({ commit, dispatch }, { slug }) => {
    try {
      const {
        data: {
          data: { items }
        }
      } = await axios.get(`${path}/api/pony/${slug}/variants`);

      return items;
    } catch (error) {
      console.error(error);
      commit('SET_ERROR', error);
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not fetch variants for this pony. try again later.',
        { root: true }
      );
    }
  },
  ADD_VARIANTS: async ({ commit }, { slug }) => {
    const {
      data: {
        data: { items }
      }
    } = await axios.get(`${path}/api/pony/${slug}/variants`);
    commit('ADD_VARIANTS', {
      items,
      slug
    });
  },
  FETCH_RELATED: async ({ commit, dispatch }, { slug }) => {
    try {
      const {
        data: {
          data: { items }
        }
      } = await axios.get(`${path}/api/pony/${slug}/related`);

      return items;
    } catch (error) {
      console.error(error);
      commit('SET_ERROR', error);
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not related ponies. try again later.',
        { root: true }
      );
    }
  },
  FETCH_GROUP_PONIES: async ({ commit }, { slug }) => {
    const {
      data: {
        data: { items }
      }
    } = await axios.get(`${path}/api/pony/${slug}/related`);
    commit('ADD_RELATED', {
      items,
      slug
    });
  },
  ADD: async ({ commit, dispatch }, payload) => {
    try {
      const { data } = await axios.post(`${path}/api/pony/create`, payload);
      commit('ADD_PONY', data.item);
      dispatch(
        'notification/SUCCESS_NOTIFICATION',
        'the new pony was added successfully',
        { root: true }
      );
    } catch (error) {
      console.error(error);
      commit('SET_ERROR', error);
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'pony could not be added. try again later.',
        { root: true }
      );
    }
  },
  UPDATE: async ({ commit, dispatch }, payload) => {
    try {
      const { data } = await axios.put(`${path}/api/pony/${payload.id}`, payload);
      commit('UPDATE_PONY', data.item);
      dispatch(
        'notification/SUCCESS_NOTIFICATION',
        'the pony was update successfully',
        { root: true }
      );
    } catch (error) {
      console.error(error);
      commit('SET_ERROR', error);
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'pony could not be updated. try again later.',
        { root: true }
      );
    }
  },
  REMOVE: async ({ commit, dispatch }, { slug }) => {
    try {
      await axios.delete(`${path}/api/pony/${slug}`);
      commit('REMOVE_PONY', slug);
      dispatch(
        'notification/SUCCESS_NOTIFICATION',
        'the pony was removed successfully',
        { root: true }
      );
    } catch (error) {
      console.error(error);
      commit('SET_ERROR', error);
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'pony could not be removed. try again later.',
        { root: true }
      );
    }
  },
  TOGGLE_WISHLIST_STATUS: async ({ commit }, { slug, inWishlist }) => {
    // update pony's wishlist status
    if (inWishlist) {
      await axios.post(`${path}/api/wishlist-item/create`, { slug });
    } else {
      await axios.delete(`${path}/api/wishlist-item/${slug}`);
    }

    commit('UPDATE_WISHLIST_STATUS', { slug, inWishlist });
    commit('UPDATE_WISHLIST_COUNT', { slug, inWishlist });
  },
  TOGGLE_FAVORITE_STATUS: async ({ commit }, { slug, inFavorites }) => {
    // update pony's favorite status
    if (inFavorites) {
      await axios.post(`${path}/api/favorite-item/create`, { slug });
    } else {
      await axios.delete(`${path}/api/favorite-item/${slug}`);
    }

    commit('UPDATE_FAVORITE_STATUS', { slug, inFavorites });
    commit('UPDATE_FAVORITE_COUNT', { slug, inFavorites });
  },
  ADD_TO_HERD: async ({ commit }, { slug }) => {
    await axios.post(`${path}/api/herd-item/create`, {
      slug,
      collectible_type: 'pony'
    });

    commit('UPDATE_HERD_STATUS', { slug, inHerd: true });
    commit('UPDATE_HERD_COUNT', { slug, inHerd: true });
  },
  REMOVE_FROM_HERD: async ({ commit }, { itemId, slug }) => {
    await axios.delete(`${path}/api/herd-item/${itemId}`);

    commit('UPDATE_HERD_STATUS', { slug: slug, inHerd: true });
    commit('UPDATE_HERD_COUNT', { slug: slug, inHerd: true });
  },
  CLEAR_FILTERS: ({ commit, dispatch }, { num }) => {
    commit('RESET_FILTERS');
    dispatch('FETCH_ALL', { num });
  },
  UPDATE_FILTERS: ({ commit, dispatch }, payload) => {
    commit('UPDATE_FILTERS', payload);
    dispatch('FILTER');
  },
  FILTER: async ({ commit, dispatch }) => {
    commit('UPDATE_STATUS', 'loading');
    let url = buildUrl(`${path}/api/ponies/`, state.filters);

    try {
      const { data } = await axios.get(url);

      commit('UPDATE_STATUS', 'success');
      commit('SET_ITEMS', data);
    } catch (error) {
      console.error(error);
      commit('UPDATE_STATUS', 'error');
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not fetch items. try again later.',
        { root: true }
      );
    }
  },
  CHANGE_DISPLAY_STYLE: ({ commit }, { display }) => {
    commit('UPDATE_DISPLAY_STYLE', { display });
  },
  SORT: ({ commit }, { direction, field }) => {
    commit('SORT_PONIES', { direction, field });
  }
};

const mutations = {
  UPDATE_STATUS: (state, status) => (state.status = status),
  RESET_ERRORS: state => (state.errors = []),
  SET_ERROR: (state, error) => {
    if (error && error.response) {
      state.errors = state.errors.concat(error.response.data.errors);
    }
  },
  SET_ITEMS: (state, data) => {
    state.items = data.data.items;
    state.heading = data.data.heading;
    state.description = data.data.description;
    state.nextUrl = data.links.next;
    state.total = data.meta.total;
  },
  ADD_ITEMS: (state, data) => {
    state.items = state.items.concat(data.data.items);
    state.nextUrl = data.links.next;
  },
  ADD_PONY: (state, data) => {
    state.items = state.items.concat(data);
  },
  ADD_IMAGES: (state, data) => {
    const pony = state.items.find(o => {
      return o.slug === data.slug;
    });

    if (pony) {
      pony.images = data.images;
    }
  },
  UPDATE_IMAGES: (state, data) => {
    const pony = state.items.find(o => {
      return o.slug === data.slug;
    });

    pony.images = pony.images.map((o, index) => {
      if (index === data.currentImage) {
        o.show = true;
      } else {
        o.show = false;
      }

      return o;
    });
  },
  UPDATE_PONY: (state, data) => {
    // fetch next "page" of groups that belong to the pony
    state.items = state.items.map(o => {
      o.slug === data.slug;
      o.name = data.name;
      o.description = data.description;

      return o;
    });
  },
  REMOVE_PONY: (state, slug) => {
    state.items = state.items.filter(o => {
      o.slug !== slug;
    });
  },
  ADD_VARIANTS: (state, data) => {
    const pony = state.items.find(o => {
      return o.slug === data.slug;
    });

    if (pony) {
      pony.variants = data.items;
    }
  },
  ADD_RELATED: (state, data) => {
    const pony = state.items.find(o => {
      return o.slug === data.slug;
    });

    if (pony) {
      pony.related = data.items;
    }
  },
  ADD_ACCESSORIES: (state, { slug, accessories }) => {
    const pony = state.items.find(o => {
      return o.slug === slug;
    });

    if (pony) {
      pony.accessories = accessories;
      // console.log('accessories', pony.accessories);
    }
  },
  UPDATE_WISHLIST_STATUS: (state, { ponySlug, inWishlist }) => {
    const pony = state.items.find(o => {
      return o.slug === ponySlug;
    });

    if (pony) {
      pony.inWishlist = inWishlist;
    }
  },
  UPDATE_WISHLIST_COUNT: (state, { ponySlug, inWishlist }) => {
    const pony = state.items.find(o => {
      return o.slug === ponySlug;
    });

    if (pony) {
      pony.wishlisted = inWishlist ? pony.wishlisted + 1 : pony.wishlisted - 1;
    }
  },
  UPDATE_HERD_STATUS: (state, { ponySlug, inHerd }) => {
    const pony = state.items.find(o => {
      return o.slug === ponySlug;
    });

    if (pony) {
      pony.inHerd = inHerd;
    }
  },
  UPDATE_HERD_COUNT: (state, { ponySlug, inHerd }) => {
    const pony = state.items.find(o => {
      return o.slug === ponySlug;
    });

    if (pony) {
      pony.collected = inHerd ? pony.collected + 1 : pony.collected - 1;
    }
  },
  UPDATE_FAVORITE_STATUS: (state, { ponySlug, inFavorites }) => {
    const pony = state.items.find(o => {
      return o.slug === ponySlug;
    });

    if (pony) {
      pony.inFavorites = inFavorites;
    }
  },
  UPDATE_FAVORITE_COUNT: (state, { ponySlug, inFavorites }) => {
    const pony = state.items.find(o => {
      return o.slug === ponySlug;
    });

    if (pony) {
      pony.favorited = inFavorites ? pony.favorited + 1 : pony.favorited - 1;
    }
  },
  UPDATE_FILTERS: (state, { name, value }) => {
    const filters = { ...state.filters };
    // toggle filter values
    if (filters[name] && filters[name].find(o => o === value)) {
      filters[name] = filters[name].filter(o => o !== value);
    } else if (filters[name]) {
      filters[name] = value;
    }

    state.filters = filters;
  },
  RESET_FILTERS: state => {
    state.filters = {
      moldId: [],
      poseId: [],
      bodyColorId: [],
      themeId: []
    };
  },
  UPDATE_DISPLAY_STYLE(state, { display }) {
    state.displayStyle = display;
  },
  SORT_PONIES(state, { direction, field = 'name' }) {
    if (state.items && state.items.length) {
      state.sorts = state.sorts.map(o => {
        if (o.active) {
          o.active = false;
        }
  
        if (o.field === field) {
          o.direction = direction;
          o.active = true;
        }
  
        return o;
      });
      state.items = sort([...state.items], direction, field);
    }
  },
  CLEAR_ITEMS(state) {
    state.items = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
